import {WHITE_BUTTON_COLOR, DARK_GREY_BUTTON_COLOR, GREY_BUTTON_COLOR, RED_BUTTON_COLOR, LIGHT_BLACK_BUTTON_COLOR, BLACK_BUTTON_COLOR, ROYAL_BLUE_COLOR} from '/constants/colors.js';
import {lightenButtonInteractions, darkenButtonInteractions,
    lightenButtonInteractionsText, darkenButtonInteractionsText,
    lightenButtonInteractionsAnotherElement, darkenButtonInteractionsAnotherElement, 
    lightenButtonInteractionsAnotherElementText, darkenButtonInteractionsAnotherElementText} from '/misc_functions/button_color_changes.js';

const backgroundColors = {
    'white' : WHITE_BUTTON_COLOR,
    'grey' : GREY_BUTTON_COLOR,
    'gray' : GREY_BUTTON_COLOR,
    'dark-grey' : DARK_GREY_BUTTON_COLOR,
    'dark-gray' : DARK_GREY_BUTTON_COLOR,
    'light-black' : LIGHT_BLACK_BUTTON_COLOR,
    'black' : BLACK_BUTTON_COLOR,
    'red' : RED_BUTTON_COLOR,
    'royalblue' : ROYAL_BLUE_COLOR
}

const buttonInteractions = {
    'lighten' : lightenButtonInteractions,
    'darken' : darkenButtonInteractions
}

const buttonInteractionsText = {
    'lighten' : lightenButtonInteractionsText,
    'darken' : darkenButtonInteractionsText
}

const buttonInteractionsAnother = {
    'lighten' : lightenButtonInteractionsAnotherElement,
    'darken' : darkenButtonInteractionsAnotherElement
}

const buttonInteractionsTextAnother = {
    'lighten' : lightenButtonInteractionsAnotherElementText,
    'darken' : darkenButtonInteractionsAnotherElementText
}

export function makeNewButton(element, buttonBackground, buttonColor, innerText, interactions=null, interactionsText=null) {

    element.style.background = buttonBackground;

    if(backgroundColors[buttonBackground]!==null && backgroundColors[buttonBackground]!==undefined)
        element.style.background = backgroundColors[buttonBackground];
    else
        element.style.background = buttonBackground;

    if(interactions!==null)
        buttonInteractions[interactions](element);

    if(backgroundColors[buttonColor]!==null && backgroundColors[buttonBackground]!==undefined)
        element.style.color = backgroundColors[buttonColor];
    else
        element.style.color = buttonColor;

    if(interactionsText!==null)
        buttonInteractionsText[interactionsText](element);

    if(innerText!==null) {
        element.innerText = innerText;
    }
}

export function makeNewButtonAffectingDifferentElement(element, elementAffected, buttonBackground, buttonColor, innerText, interactions=null, interactionsText=null) {

    elementAffected.style.background = buttonBackground;

    if(backgroundColors[buttonBackground]!==null)
        elementAffected.style.background = backgroundColors[buttonBackground];
    else
        elementAffected.style.background = buttonBackground;

    if(interactions!==null)
        buttonInteractionsAnother[interactions](element, elementAffected);

    if(interactionsText!==null)
        buttonInteractionsTextAnother[interactionsText](element, elementAffected);

    elementAffected.style.color = buttonColor;

    if(innerText!==null) {
        elementAffected.innerText = innerText;
    }

}